import type { RagTableType } from './rag.js';

export const MAX_FOLDER_DEPTH = 2;

export const ROOT_FOLDER_ID = '__kb_root__';

export type FolderNode = {
  kind: 'folder';
  id: string;
  name: string;
  parentId: string;
  fileType: 'folder';
};

export type FileNode = { kind: 'file'; id: string } & RagTableType;

export type FileSystemNode = FolderNode | FileNode;

export type FolderCrumb = {
  folderId: string;
  name: string;
};
